import { Tool } from '../../data/tools';

export const metadata: Tool = {
  id: 'sunrise-sunset',
  name: 'Sunrise, Sunset & Golden Hour Calculator',
  description: 'Calculate local sunrise, sunset, golden hour, and day length intervals based on geolocation.',
  category: 'Earth & Space',
  icon: 'Sun',
  route: '/tools/sunrise-sunset',
  metaTitle: 'Sunrise & Sunset Calculator — Golden Hour Photographer Tool',
  metaDescription: 'Calculate precise local sunrise, sunset, golden hour, and solar noon times. Uses geolocation or custom coordinates to compute day length and sun tracks.',
  keywords: [
    'sunrise calculator',
    'sunset tracker',
    'golden hour calculator',
    'photographer golden hour',
    'sunrise times',
    'sunset times',
    'solar noon finder',
    'day length calculator'
  ],
  longDescription: 'The Sunrise, Sunset & Golden Hour Calculator calculates precise astronomical markers for any location on Earth. Ideal for photographers seeking the golden hour, travelers planning outdoor activities, and solar energy estimators.',
  howToUse: [
    'Allow browser location access to automatically fetch your local coordinates, or input latitude and longitude coordinates manually.',
    'Review the computed times for sunrise, sunset, solar noon, and civil/nautical/astronomical twilight intervals.',
    'Use the dynamic sun path visualizer dial to track the current position of the sun.',
    'View the total day length and remaining hours of daylight for the selected location.'
  ],
  benefits: [
    'Fetches live geolocation details securely from standard browser APIs.',
    'No third-party trackers or credit cards required; runs fully client-side.',
    'Includes photogeographic golden hour and twilight interval calculations.'
  ],
  faq: [
    {
      question: 'What is the "Golden Hour"?',
      answer: 'The golden hour (sometimes called magic hour) is the period of daytime shortly after sunrise or before sunset, during which daylight is redder and softer than when the sun is higher in the sky. It is highly prized by photographers.'
    },
    {
      question: 'How does the browser find my location?',
      answer: 'The calculator requests access to the HTML5 Geolocation API. If approved, the browser retrieves approximate coordinates via GPS, cell tower data, or IP address. Your coordinates are never sent to a server.'
    },
    {
      question: 'Why are the computed times slightly different from standard weather apps?',
      answer: 'This calculator computes times based on official mathematical equations that estimate refractive atmospheric delays. Differences are usually minimal (within 1-2 minutes) depending on your altitude.'
    }
  ]
};
